import {
    getSchedulerMetadata
} from "api/onboarding/scheduler/onboardingScheduler";

window.Scheduler = {
    loadPrefs: function() {
        getSchedulerMetadata().then(res => {
            if (res.isConfigured) {
                MyWindow.close();
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupSchedulerSettings.display = true
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupSchedulerSettings.props = { defaultEmail: res?.email.email }
            } else {
                window.sellsyapp.config.globalProperties.$router.replace('/onboarding/scheduler')
            }
        })
    }
}
